module.exports = __webpack_public_path__ + "img/logo_balai_pustaka.63124965.jpeg";